// Automatic replies and business hours (ADR-0009). Every role reads them;
// only owners and admins save, and the server enforces that.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api, unwrap } from './client'
import { queryClient } from './queryClient'
import type { components } from './generated/schema'

export type AutoReplies = components['schemas']['AutoReplies']
export type KeywordRule = components['schemas']['KeywordRule']
export type BusinessDay = components['schemas']['BusinessDay']
export type AutoReplyKind = components['schemas']['AutoReplyKind']

const key = ['auto-replies'] as const

export function useAutoReplies() {
  return useQuery({
    queryKey: key,
    queryFn: async (): Promise<AutoReplies> => unwrap(await api.GET('/auto-replies')),
  })
}

// The socket said a teammate saved the settings.
export function refreshAutoReplies() {
  void queryClient.invalidateQueries({ queryKey: key })
}

export function useSaveAutoReplies() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (body: AutoReplies) => unwrap(await api.PUT('/auto-replies', { body })),
    onSuccess: (saved) => qc.setQueryData(key, saved),
  })
}

export const autoReplyLabel: Record<AutoReplyKind, string> = {
  welcome: 'Welcome message',
  away: 'Away message',
  keyword: 'Keyword reply',
}
